const TRANSLATE = {
  title: 'Usuários',
  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'menu.group': 'Cadastro de grupos',
  'menu.triggers': 'Automações',
  'menu.fields': 'Customizar campos adicionais',
  'menu.templates': 'Templates de Documento',
  'menu.templateHistory': 'Histórico de Documento',
  'menu.publicToken': 'Tokens públicos',
  name: 'Nome',
  email: 'Email',
  group: 'Grupo',
  profile: 'Perfil',
  newApp: 'Novo app?',
  enabled: 'Ativado',
  fields: {
    NAME: 'Nome',
    EMAIL: 'Email',
    GROUP_NAME: 'Grupo',
    PROFILE_NAME: 'Perfil',
    LAST_LOGIN_AT: 'Último login'
  },
  pageGuide: {
    description:
      'Em usuários, você dará acesso à todas as pessoas da sua equipe que usarão a Btime! Aqui você pode organizar a sua equipe por meio dos perfis, definindo o que cada um tem acesso e o que pode ou não fazer',
    howToCreate: 'Como criar um usuário?',
    howToEdit: 'Como editar um usuário?',
    howToDelete: 'Como excluir um usuário?',
    howToFilter: 'Como filtrar a listagem de usuários?',
    contactSupport: 'Entre em contato e tire suas dúvidas'
  }
}

export default TRANSLATE
